import React, {useEffect} from 'react';
import {TextField, ThemeProvider} from "@mui/material";

import "./RegistrationForm.css";
import {THEME} from "../../theme/PacsTheme";
import {isNotNull, isValidEmail, isValidPhoneNumber, isValidText} from "../../util/Validators";

export default function RegistrationForm(props) {

    const validateErrors=isNotNull(props.validateErrors) ? props.validateErrors : false;
    const update = props.watch;
    const [ready, setReady] = React.useState(false);
    const handleValidate = props.onValidate;

    const [data, setData] = React.useState({
        firstname: {
                        value : "",
                        error: false,
                        validator: (val) => { return isValidText(val, 2, 50) },
                        errorText: "First Name must be at least 2 characters"
                    },
        lastname:   {
                        value : "",
                        error: false,
                        validator: (val) => { return isValidText(val, 2, 50) },
                        errorText: "Last name must be at least 2 characters"
                    },
        email:      {
                        value : "",
                        error: false,
                        validator: (val) => { return isValidEmail(val) },
                        errorText: "Must be a valid email address"
                    },
        mobile:     {
                        value : "",
                        error: false,
                        validator: (val) => { return isValidPhoneNumber(val) },
                        errorText: "Not a valid US Mobile Number"
                    },
        title:      {
                        value : "",
                        error: false,
                        validator: (val) => { return isValidText(val, 3, 50) },
                        errorText: "Title must be at least 3 characters"
                    },
        company:    {
                        value : "",
                        error: false,
                        validator: (val) => { return isValidText(val, 3, 50) },
                        errorText: "Company must be at least 3 characters"
                    }
    });

    const dataComplete = () => {

        let errors = 0;
        let incomplete = 0;

        const keys = Object.keys(data);

        keys.forEach((key) => {
            errors += data[key].error ? 1 : 0;
            incomplete += data[key].value.length === 0 ? 1 : 0;
        })

        return errors === 0 && incomplete === 0;
    }

    const handleChange = (obj) => {
        const copy = {...data};
        copy[obj.target.name].value = obj.target.value;

        setData(copy);

        if (dataComplete()) {
            setReady(true);
        } else if (ready) {
            setReady(false);
        }

        update.watch(update.name, copy);
    }

    const handleBlur = (obj) => {

        const validator = data[obj.target.name].validator;

        if (isNotNull(validator)) {

            const copy = {...data};
            copy[obj.target.name].error = !validator(obj.target.value);

            setData(copy);
        }

        if (dataComplete()) {
            setReady(true);
        } else if (ready) {
            setReady(false);
        }
    }

    useEffect(() => {

        if (validateErrors) {
            const keys = Object.keys(data);
            const copy = {...data};

            keys.forEach((key) => {
                const validator = data[key].validator;
                copy[key].error = !validator(copy[key].value);
            })

            setData(copy);
            update.watch(update.name, copy);
            handleValidate();
        }

    }, [validateErrors]);

    return (
        <React.Fragment>
            <div
                style={{
                    marginLeft: "auto",
                    marginRight: "auto",
                }}
                className={"default-form-width default-margin-top-xlarge"}
            >
                <ThemeProvider theme={THEME}>
                <div
                    style={{
                        marginBottom: "15px",
                        marginTop: "10px",
                    }}
                    className={"default-font-color-dark default-font-bold default-font-xlarge"}
                >
                    Attendee Details
                </div>
                <div
                    style={{
                        paddingLeft: "20px",
                        paddingRight: "20px",
                    }}
                    className={"default-display-flex"}
                >
                    <div
                        className={"registration-form-textfield default-max-grow-50 default-max-width"}>
                        <TextField
                            className={"default-max-width"}
                            name={"firstname"}
                            variant={"outlined"}
                            label={"First Name"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={data.firstname.value}
                            error={data.firstname.error}
                            helperText={data.firstname.error ? data.firstname.errorText : ""}
                        />
                    </div>
                    <div className={"registration-form-textfield default-max-grow-50 default-max-width"}>
                        <TextField
                            className={"default-max-width"}
                            name={"lastname"}
                            variant={"outlined"}
                            label={"Last Name"}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={data.lastname.value}
                            error={data.lastname.error}
                            helperText={data.lastname.error ? data.lastname.errorText : ""}
                        />
                    </div>
                </div>
                <div
                    style={{
                        paddingLeft: "20px",
                        paddingRight: "20px",
                    }}
                    className={"default-display-flex"}
                >
                    <div
                        className={"registration-form-textfield default-max-grow-50 default-max-width"}>
                        <TextField
                            className={"default-max-width"}
                            name={"email"}
                            variant={"outlined"}
                            label={"Email Address"}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={data.email.value}
                            error={data.email.error}
                            helperText={data.email.error ? data.email.errorText : ""}
                        />
                    </div>
                    <div className={"registration-form-textfield default-max-grow-50 default-max-width"}>
                        <TextField
                            className={"default-max-width"}
                            name={"mobile"}
                            variant={"outlined"}
                            label={"Mobile"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={data.mobile.value}
                            error={data.mobile.error}
                            helperText={data.mobile.error ? data.mobile.errorText : ""}
                        />
                    </div>
                </div>
                <div
                    style={{
                        paddingLeft: "20px",
                        paddingRight: "20px",
                    }}
                    className={"default-display-flex"}
                >
                    <div
                        className={"registration-form-textfield default-max-grow-50 default-max-width"}>
                        <TextField
                            className={"default-max-width"}
                            name={"company"}
                            variant={"outlined"}
                            label={"Company"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={data.company.value}
                            error={data.company.error}
                            helperText={data.company.error ? data.company.errorText : ""}
                        />
                    </div>
                    <div className={"registration-form-textfield default-max-grow-50 default-max-width"}>
                        <TextField
                            className={"default-max-width"}
                            name={"title"}
                            variant={"outlined"}
                            label={"Title"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={data.title.value}
                            error={data.title.error}
                            helperText={data.title.error ? data.title.errorText : ""}
                        />
                    </div>
                </div>

                </ThemeProvider>
            </div>

        </React.Fragment>
    )

}